import { render, staticRenderFns } from "./RichTextContent.vue?vue&type=template&id=4bb7b476"
import script from "./RichTextContent.vue?vue&type=script&lang=js"
export * from "./RichTextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports